export const colors = {
    mainDark: "rgba(7, 83, 91)",
    greyFrame: "#636161",
    greyBoldFrame: "#3D3D3D",
    greyLight: "#D3D3D3",
    green: "#B3F8CA",
    greenWord: "#119B3F",
    darkGreen: "#0c5525",
    myprogress: "#072b5b",
    grammar: "#5B0807",
    reading: "#072b5b",
    headingColor: "#044AEF",
}